import React from "react";
import { Box, Typography, Card, Avatar, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Base URL for images
const BASE_IMAGE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod";
const DUMMY_IMAGE = `${BASE_IMAGE_URL}/dummy-vm-image.png`;

const NearbyVmList = ({ nearbyVmlist = [], loading, onFetchLocation }) => {
  const navigate = useNavigate();
  const hasVms = nearbyVmlist && nearbyVmlist.length > 0;
  //console.log("nearbyVmlist",nearbyVmlist)

  const handleCardClick = (vmId) => {
    navigate(`items?machineId=${vmId}&value=null&showItems=true`); // Navigate to VM detail page
   
  };

  return (
    <Box>
<Typography
  variant="h5"
  gutterBottom
  sx={{
    marginTop: '5%',
        
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,           // ✅ overrides default variant weight
    fontSize: '17px',          // ✅ specific font size
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
    color: 'rgba(113, 129, 152, 1)',
  }}
>
  Nearby  Vending Machine
</Typography>




      {loading && (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      )}

      {!loading && !hasVms && (
        <Typography variant="body2" color="textSecondary">
          No vending machines found. Please allow location access.
        </Typography>
      )}

      {hasVms && (
        <Box style={{marginBottom:"70px"}} display="grid" gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))" gap={2} mt={2} >
          {nearbyVmlist.map((vm) => {
            const imageUrl = vm.machineImagePath
              ? `${BASE_IMAGE_URL}/${vm.machineImagePath}`
              : DUMMY_IMAGE;

            return (
              <Card
                key={vm.id}
                onClick={() => handleCardClick(vm.id)}
                sx={{
                  borderRadius: 2,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  cursor: "pointer", // pointer cursor on hover
                  "&:hover": {
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)", // hover effect
                  },
                }}
              >
                <Avatar
                  src={imageUrl}
                  alt={vm.outletName}
                  variant="rounded"
                  sx={{ width: 60, height: 60, mr: 2 }}
                />
                <Box>
                  <Typography variant="subtitle1">{vm.outletName}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {vm.name}
                  </Typography>
                  {vm.address && (
                    <Typography variant="body2" color="textSecondary">
                      {`${vm.address}`}
                    </Typography>
                  )}
                </Box>
              </Card>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default NearbyVmList;
